import * as Yup from 'yup';
export const rntFieldSchema = Yup.object().shape({
  rnt: Yup.string()
    .matches(/^RNT\d{11}$/i, 'TenantPay account number must start with RNT and be 11 digits')
    .required('TenantPay account number is required'),
});
